module.exports = __webpack_public_path__ + "static/media/tunetalk.240c248d.png";